var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "track-select dropdown v-select",
      class: _vm.dropdownClasses,
      attrs: { dir: _vm.dir },
    },
    [
      _c(
        "div",
        {
          ref: "toggle",
          class: ["dropdown-toggle", "clearfix"],
          on: {
            mousedown: function ($event) {
              $event.preventDefault()
              return _vm.toggleDropdown.apply(null, arguments)
            },
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search",
              },
            ],
            ref: "search",
            staticClass: "form-control",
            staticStyle: { width: "100%" },
            attrs: {
              type: "search",
              autocomplete: _vm.autocomplete,
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              tabindex: _vm.tabindex,
              readonly: !_vm.searchable,
              id: "searchInput",
              "aria-label": "Search for option",
            },
            domProps: { value: _vm.search },
            on: {
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                      "Backspace",
                      "Delete",
                      "Del",
                    ])
                  )
                    return null
                  return _vm.maybeDeleteValue.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp",
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.typeAheadUp.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown",
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.typeAheadDown.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.typeAheadSelect.apply(null, arguments)
                },
              ],
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  return _vm.onEscape.apply(null, arguments)
                },
                _vm.onSearchKeyUp,
              ],
              blur: _vm.onSearchBlur,
              focus: _vm.onSearchFocus,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.search = $event.target.value
              },
            },
          }),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showClearButton,
                  expression: "showClearButton",
                },
              ],
              staticClass: "clear",
              attrs: {
                disabled: _vm.disabled,
                type: "button",
                title: "Clear selection",
              },
              on: { click: _vm.clearSelection },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
          !_vm.noDrop
            ? _c("i", {
                ref: "openIndicator",
                staticClass: "open-indicator",
                staticStyle: { width: "10px" },
                attrs: { role: "presentation" },
              })
            : _vm._e(),
        ]
      ),
      _c("transition", { attrs: { name: _vm.transition } }, [
        _vm.dropdownOpen && _vm.filteredOptions.length
          ? _c(
              "ul",
              {
                ref: "dropdownMenu",
                staticClass: "dropdown-menu trackplus-dropdown",
                style: { "max-height": _vm.maxHeight },
              },
              [
                _vm._l(_vm.filteredOptions, function (option, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      on: {
                        mouseover: function ($event) {
                          _vm.typeAheadPointer = index
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            mousedown: function ($event) {
                              $event.preventDefault()
                              return _vm.select(option)
                            },
                          },
                        },
                        [
                          _vm._t(
                            "option",
                            function () {
                              return [
                                _vm._v(_vm._s(_vm.getOptionLabel(option))),
                              ]
                            },
                            null,
                            option
                          ),
                        ],
                        2
                      ),
                    ]
                  )
                }),
                !_vm.filteredOptions.length && !_vm.allowToAddItem
                  ? _c(
                      "li",
                      { staticClass: "no-options" },
                      [
                        _vm._t("no-options", function () {
                          return [_vm._v("Sorry, no matching options.")]
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }